// DebugWarnings.jsx
export function DebugWarnings({ children }) {
  if (typeof window === "undefined") return null;

  // const allowedHostnames = ["localhost", "jigpawsstaging.web.app"];
  const hostname = window.location.hostname;
  const isDebugHost = hostname === "localhost" || hostname.includes("jigpawsstaging");

  if (!isDebugHost) return null;

  return (
    <div
      style={{


          color: "Red",
      }}
    >
      {children}
    </div>
  );
}
export const DEBUG = true; // toggle this once for all DebugContainers

export function DebugOutput({ children }) {
  if (typeof window === "undefined") return null;

  const hostname = window.location.hostname;
  const isDebugHost = ["localhost", "jigpawsstaging.web.app"].includes(hostname);

  // Only show if both DEBUG flag is true and we're on a debug host
  if (!DEBUG || !isDebugHost) return null;

  return (
    <div>
      {children}
    </div>
  );
}

//DebugContainer
export function DebugContainer({ children }) {
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

const isDebugHost = hostname === "localhost" || hostname.includes("jigpawsstaging");

  const isActive = DEBUG && isDebugHost;

  if (!isActive) return null;

  return (
    <div className="jpDebug jpDebug--active">
      {children}
    </div>
  );
}